import { CircularProgress } from '@mui/material';

import { ICON_SIZE_PX } from '../../../constants/buttons';
import { BLACK_COLOR, WHITE_COLOR } from '../../../constants/colors';
import { IIconButton } from '../../../interfaces/buttons';
import type { IconButtonVariant } from '../../../types/buttons';

import './IconButton.scss';

const spinnerStyles: Record<IconButtonVariant, { color: string }> = {
  primary: { color: WHITE_COLOR },
  secondary: { color: BLACK_COLOR },
  transparent: { color: BLACK_COLOR },
  inverse: { color: BLACK_COLOR },
  transparentInverse: { color: WHITE_COLOR },
  secondaryInverse: { color: WHITE_COLOR }
};

const IconButton = ({
  icon,
  action,
  disabled,
  loading,
  variant,
  size,
  label,
  className,
  onMouseEnter,
  onMouseLeave
}: IIconButton) => {
  const classNames = ['icon-button', `icon-button--${variant}`, `icon-button--${size}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disabled={loading || disabled}
      aria-label={label}
      className={classNames}
      onClick={action}
    >
      {loading && <CircularProgress sx={{ ...spinnerStyles[variant] }} size={ICON_SIZE_PX[size]} />}
      {!loading && icon && <icon.component />}
    </button>
  );
};

export default IconButton;
